import { Component, Inject } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DistributionsService } from 'src/app/services/distributions.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-rack-comparte-inv',
  templateUrl: './rack-comparte-inv.component.html',
  styleUrls: ['./rack-comparte-inv.component.scss']
})
export class RackComparteInvComponent {

  rack!: any;
  estaciones!: any;
  materiales_est:any;
  select_estaciones:any;
  rack_sel:any = 0;
  saveEst: boolean = true;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data : any,
    private distS: DistributionsService,
    private dialogRef: MatDialogRef<RackComparteInvComponent>,
  ) {
    this.rack = this.data.rack;
    this.estaciones = this.data.estaciones;
    console.log(this.data)
  }


  ngOnInit(): void {    
    if(this.rack.id_comparte != null){
      this.rack_sel = this.rack.id_comparte;
    }
    else{
      this.rack_sel = 'Ninguna';
    }
    this.getMaterialList(this.data.rack.id);
  }

  getMaterialList(rack_id: number) {
    //Para obtener los materiales de la estacion actual
    let mats = JSON.parse(this.rack.materiales);

    if(mats != null){
      this.materiales_est = mats.map((r: any) => r.id)
    }
    this.getEstaciones();
  }

  getEstaciones(){
    //Obtiene estaciones de diferente linea que tengan los mismo materiales que la estacion que seleccioné
    this.select_estaciones = this.estaciones.filter((e: any) => {

      if (e.line == this.rack.line) return false;

      const materials = JSON.parse(e.materiales);
    
      const m_compare = materials?.map((r: any) => r.id) ?? [];

      const iguales =
        this.materiales_est.length === m_compare.length &&
        [...this.materiales_est].sort().every(
          (val: any, i: any) => val === [...m_compare].sort()[i]
        );

      return iguales;
    });

    const comparte = this.select_estaciones.find( (x:any) => x.id_comparte == this.rack.id);

    if(comparte){
      this.rack_sel = comparte.id;
      this.saveEst = false;
    }

  }

  guardarEstacionCompartida() {

    let rack = this.rack_sel == 'Ninguna' ? null : this.rack_sel

    let dataSend = {
      id_rack: this.data.rack.id,
      rack_comparte: rack,
    }

    this.distS.updateRackEstacionComparte(dataSend).subscribe(
      (result: any) => {
        if (result.message == "Success") {
          Swal.fire({
            icon: 'success',
            title: 'Guardado'
          }).then(() => {
            this.dialogRef.close({ reload: true });
          });
        }
      },
      (err: any) => {
        Swal.fire({
          icon: 'error',
          title: 'Error al guardar',
          text: 'Ocurrió un error al guardar el registro, por favor vuelva a intentarlo.'
        });
      }
    );

  }
  


}
